import { render, staticRenderFns } from "./ErrPage.vue?vue&type=template&id=14b34922"
import script from "./ErrPage.vue?vue&type=script&lang=js"
export * from "./ErrPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports